import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { ErrorBoundary } from '@warehouselogix/web-common';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AdminApp } from './AdminApp';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Root element #root not found in index.html.');
}

/**
 * Composition root for the WarehouseLogix admin console. Providers wrap the app
 * from the outside in:
 *   ErrorBoundary (catches render failures anywhere below)
 *     → FluentProvider (light theme + Griffel style host)
 *       → BrowserRouter (client-side routing, ready for the real screens)
 *         → AdminApp (MSAL AuthProvider + auth-gated shell).
 * FluentProvider sits above the router so themed chrome renders on every route.
 */
createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <FluentProvider theme={webLightTheme}>
        <BrowserRouter>
          <AdminApp />
        </BrowserRouter>
      </FluentProvider>
    </ErrorBoundary>
  </StrictMode>
);
